import { createSelector } from 'reselect'
import { ConfigManager } from '~/managers/ConfigManager'
import { CommonState } from '~/store/types'

const selectRouteState = (state: CommonState) => state.route

const selectUser = createSelector([selectRouteState], state => state.user)

export const selectUserEmail = createSelector([selectUser], user => user.email)

export const selectUserBizId = createSelector([selectUser], user =>
  ConfigManager.isAppSite() ? undefined : user.bizId
)

export const selectUserAuthServerUrl = createSelector([selectUser], user => user.authServerUrl)

export const selectIsFiatWalletOnly = createSelector([selectUser], user =>
  ConfigManager.isBizSite() ? user.isFiatWalletOnly : false
)

export const selectIsUsingFiatCurrency = createSelector(
  [selectRouteState],
  state => state.isUsingFiatCurrency
)

export const selectIsTwoFaExist = createSelector(
  [selectUser],
  user => !!user.twoFa.twoFaList.length
)

export const selectTwoFaSetupTime = createSelector([selectUser], user =>
  Number(user.twoFa.twoFaSetupTime)
)

export const selectIsStablecoinTransferDisclaimerAcknowledged = createSelector(
  [selectUser],
  user => {
    if (ConfigManager.isBizSite()) {
      return false
    }
    return user.isStablecoinTransferDisclaimerAcknowledged
  }
)
